/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Text = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M17 6.1H3" }],
    ["path", { d: "M21 12.1H3" }],
    ["path", { d: "M15.1 18H3" }]
  ]
];

export { Text as default };
//# sourceMappingURL=text.js.map
